<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
      <app-left-navbar></app-left-navbar>
    </mat-sidenav>
    <mat-sidenav-content style="background-color: bisque;">
      <mat-toolbar class="pageHeader">
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
          *ngIf="isHandset$ | async">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
        <span>Student ID Number</span>
      </mat-toolbar>
      <!-- Add Content Here -->
      <div class="content-body">
        <div class="main-panel">
          <div class="content-wrapper">
            <!-- Page Title Header Starts-->
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="content-header">
                  <p>Click to generate Student Identification Number for each student.</p>
                  <mat-divider></mat-divider>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="total-header">
                  <div class="row">
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>